import { Layout, AppBar } from 'react-admin';
import { Box } from '@mui/material';
import { CustomMenu } from './CustomMenu';
import { BranchSelector } from '../components/BranchSelector';
import { BranchProvider } from '../context/BranchContext';

const CustomAppBar = () => (
    <AppBar>
        <Box sx={{ flex: 1 }} />
        <BranchSelector />
    </AppBar>
);

export const CustomLayout = (props: any) => (
    <BranchProvider>
        <Layout {...props} menu={CustomMenu} appBar={CustomAppBar} />
    </BranchProvider>
);
